import { render, staticRenderFns } from "./CollectInformation.vue?vue&type=template&id=6cbe4375&scoped=true"
import script from "./CollectInformation.vue?vue&type=script&lang=js"
export * from "./CollectInformation.vue?vue&type=script&lang=js"
import style0 from "./CollectInformation.vue?vue&type=style&index=0&id=6cbe4375&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe4375",
  null
  
)

export default component.exports